export default __webpack_public_path__ + "static/media/KZ.T.10.2064 black.e910d00a.svg";